module.exports = __webpack_public_path__ + "static/media/iconVideoLastStepHorizontal.114ad2ba.svg";